import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import TypeWork from '../../ui/TypeWork';
import WorkCheckList from '../../ui/WorkCheckList';
import Complete from '../../ui/Complete';
import BackClickBottomSheet from '../../ui/BackClickBottomSheet';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { useDispatch, useSelector } from 'react-redux';
import BasicInfoForm from '../../M_PER_CUSTOM/ui/BaseInfoForm';
import { NavBarInfoActions } from '../../../../Reducer/NavBarInfoReducer';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';

export default function M_PER_BASIC_01(props) {
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const currentStep = props.activeStep > 0 ? props.activeStep : 1;
  const ToggleDrawer =
    props.ToggleDrawer ??
    ((anchor, open) => () => {
      dispatch(
        BottomSheetActions.SetBottomSheetState({
          bottom: open,
          type: bottomSheetState?.type,
        })
      );
    });

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 허가서'));
    dispatch(CommonActions.setActiveStep(1));
  }, [dispatch]);

  const steps = {
    1: (
      <BasicInfoForm
        variant="BASIC"
        form={props.inputBaseInfo}
        errors={props.errors}
        handleChange={props.handleChange}
        userInfo={props.userInfo}
        rowData2={props.rowData2}
        ValidateAll={props.ValidateAll}
        ToggleDrawer={ToggleDrawer}
      />
    ),
    2: (
      <TypeWork
        form={props.inputBaseInfo}
        setInput={props.setInputBaseInfo}
        SaveLogic1={props.SaveLogic1}
        codeList={props.codeList?.workTypes}
        SearchLogic2={props.SearchLogic2}
        selectedDepHeadId={props.selectedDepHeadId}
        setSelectedDepHeadId={props.setSelectedDepHeadId}
        rowData1={props.rowData1}
        userInfo={props.userInfo}
        rowData2={props.rowData2}
      />
    ),
    3: (
      <WorkCheckList
        form={props.inputBaseInfo}
        SaveLogic1={props.SaveLogic1}
        SaveLogic2={props.SaveLogic2}
        userInfo={props.userInfo}
        rowData1={props.rowData1}
        rowData2={props.rowData2}
        rowData3={props.rowData3}
        handleSignRequest={props.handleSignRequest}
        workTypes={props.codeList?.workTypes}
        codeList={props.codeListForCheckList}
        SearchLogic2={props.SearchLogic2}
        selectedDepHeadId={props.selectedDepHeadId}
        setSelectedDepHeadId={props.setSelectedDepHeadId}
        ToggleDrawer={ToggleDrawer}
      />
    ),
    4: <Complete />,
  };

  return (
    <Box
      sx={{
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        fontSize: '18px',
        fontWeight: 'bold',
        height: '100%',
      }}
    >
      {steps[currentStep] ? (
        steps[currentStep]
      ) : (
        <Navigate to="/M_Permit" replace />
      )}
      {/* 바텀시트 부분 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'backClick' && (
        <BackClickBottomSheet
          open={true}
          userInfo={props.userInfo}
          route={props.id ? `/M_Permit/detail/${props.id}` : '/M_Permit'}
        />
      )}
    </Box>
  );
}
